// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__yFj14","titlePart":"style_titlePart__1s7jh","pagesGrid":"style_pagesGrid__1j1P9","pageItem":"style_pageItem__tzktW"};